import React, { startTransition } from 'react';
import { Link, useNavigate } from 'react-router-dom';

export const gradients = {
  ['character-exercise']: 'from-[#FEE7F3] to-[#B7DFFA]',
  ['character-compass']: 'from-[#B7DFFA] to-[#FAE1CD]',
  quote: 'from-[#B7DFFA] to-[#F4DDED]',
  meditation: 'from-[#B7DFFA] to-[#F4DDED]',
  none: '',
};

interface PageHeaderProps {
  title: string;
  url?: string;
  type: 'character-exercise' | 'character-compass' | 'quote' | 'meditation' | 'none';
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, url, type }) => {
  const navigate = useNavigate();

  return (
    <div
      className={`
        flex items-center gap-4
        rounded-lg bg-gradient-to-r ${gradients[type]}
        px-sh-16 py-sh-10
      `}>
      {url ? (
        <Link to={url} className="arrow-back-scope">
          <span className="font-cadiz text-sh-xss font-bold">{title}</span>
        </Link>
      ) : (
        <button
          type="button"
          className="arrow-back-scope"
          onClick={() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            startTransition(() => {
              navigate(-1);
            });
          }}>
          <span className="font-cadiz text-sh-xss font-bold">{title}</span>
        </button>
      )}
    </div>
  );
};

export default PageHeader;
